import { usePublisherStore } from "~/store/PublisherModule";
import type { IChatFile } from "~/interfaces/chat";

// Вложения чата грузим тем же медиа-хранилищем, что и креативы: чат-бэк
// принимает только готовую ссылку, файлы через себя не пропускает.
const UPLOAD = "/advert/creative/content-media-item/upload";
const UPLOAD_STATUS = "/advert/creative/content-media-item/upload-check-status";

// Файл после загрузки ещё обрабатывается на бэке — постоянная ссылка
// (cloudUrl) появляется не сразу.
const STATUS_ATTEMPTS = 15;
const STATUS_DELAY = 1000;

export type ChatSide = "publisher" | "advertiser";

const getToken = (side: ChatSide): string | null => {
  if (side === "advertiser") return useCookie("accessTokenSJ").value ?? null;

  const cookieToken = useCookie("authorizedP").value;
  if (cookieToken && cookieToken !== "undefined") return cookieToken;
  return localStorage.getItem("usePublisherStore__authorized") || usePublisherStore().authorized;
};

// Content-Type не ставим: для FormData его проставляет браузер вместе с boundary
const getHeaders = (side: ChatSide) => {
  const headers: Record<string, string> = {
    "Auth-Type": side === "advertiser" ? "asAdvertiser" : "asPublisher",
  };
  const token = getToken(side);
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export default class ChatFileService {
  static upload = async (file: File, side: ChatSide): Promise<IChatFile | null> => {
    const config = useRuntimeConfig();
    const baseURL = config.public.LIGHT_API_ORIGIN as string;
    const headers = getHeaders(side);

    const body = new FormData();
    body.append("file", file);

    const uploaded: any = await $fetch(UPLOAD, { baseURL, method: "POST", body, headers });
    const uploadId = uploaded?.uploadId;
    if (!uploadId) return null;

    for (let attempt = 0; attempt < STATUS_ATTEMPTS; attempt++) {
      const status: any = await $fetch(UPLOAD_STATUS, {
        baseURL,
        headers,
        params: { "ids[]": uploadId },
      }).catch(() => null);

      const item = status?.statuses?.[uploadId];
      if (item?.status === "success" && item.cloudUrl) {
        return {
          url: item.cloudUrl,
          name: file.name,
          size: file.size,
          mime: file.type || null,
        };
      }

      await new Promise((resolve) => setTimeout(resolve, STATUS_DELAY));
    }

    return null;
  };
}
